import { Button, CircularProgress } from '@mui/material'
import theme from 'lib/theme'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const SaveBtn = ({
  isValid,
  dirty,
  showOverlay,
  isLoadingRequest,
}: {
  isValid: boolean
  dirty: boolean
  showOverlay: boolean
  isLoadingRequest: boolean
}) => {
  const { t } = useTranslation()
  return (
    <Button
      type='submit'
      sx={{
        visibility: isValid && dirty && showOverlay ? 'visible' : 'hidden',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.commonColors.white,
        marginBottom: theme.spacing(2),
        width: '100%',
      }}>
      {isLoadingRequest ? (
        <CircularProgress
          size='20px'
          sx={{
            color: theme.palette.commonColors.white,
          }}
        />
      ) : (
        t('save')
      )}
    </Button>
  )
}
